import { useTranslation } from "react-i18next";
import { CustomSelect } from '../../../../components/Shared/CustomSelect';

const Allergens = ({ allergens, options, formik, isAllDisabled }) => {
    const { t } = useTranslation();
    const handleChange = (value) => {
        const newAllergens = []
        allergens.forEach((option) => {
            value.forEach((tag) => {
                if (tag.value === option.id) {
                    newAllergens.push(option);
                }
            });
        });
        formik.setFieldValue(
            'allergens',
            newAllergens
        );
    };

    const allergenOptions = options.map((item) => ({ value: item.id, label: item.name }));
    const allergenValues = allergens.map((item) => ({ value: item.id, label: item.name }));


    return (
        <>
            <CustomSelect
                isDisabled={isAllDisabled}
                isMulti
                name="Allergens"
                options={allergenValues}
                className="w-full mt-1"
                onChange={handleChange}
                value={allergenOptions}
                placeholder={t("Select Allergens")}
            />
        </>
    );
};

export default Allergens;
